// extracted by mini-css-extract-plugin
export default {"promptSignInContainer":"PromptSignIn_promptSignInContainer__GxHd0","goToLoginButton":"PromptSignIn_goToLoginButton__ph-X0"};